<template>
    <product-wizard-provider v-slot="{product, addProduct, isLoading, campaign}">
        <product-view :product="product" :campaign="campaign" :is-loading="isLoading" @add-product="addProduct"/>
    </product-wizard-provider>
</template>
<script>
    import ProductWizardProvider from "../providers/proposal-steps/ProductWizardProvider";
    import ProductView from "../data-views/products/ProductView";

    export default {
        name: "ProductSelectionProductsRouterView",
        components: {
            ProductWizardProvider,
            ProductView,
        },
    }
</script>

